import React from "react";
import AddQTToAreaContainer from "../../modules/AreaManagement/containers/AddQTToAreaContainer/AddQTToAreaContainer";

const AreaDetailsAddQTToArea = () => {
  return <AddQTToAreaContainer />;
};

export default AreaDetailsAddQTToArea;
